import { render } from "./HomeSectionBookPickerModal.vue?vue&type=template&id=3d04e68c&scoped=true"
import script from "./HomeSectionBookPickerModal.vue?vue&type=script&lang=js"
export * from "./HomeSectionBookPickerModal.vue?vue&type=script&lang=js"

import "./HomeSectionBookPickerModal.vue?vue&type=style&index=0&id=3d04e68c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d04e68c"]])

export default __exports__